import { customersSlice } from "./customersSlice";
import * as actions from "./customersActions";
import * as selectors from "./customersSelectors";

export { actions };
export { selectors };
export default customersSlice.reducer;
